import { IdAndName } from 'src/service/view-model/base/IdAndName'
import { findReferenceObject } from 'src/service/view-model/base/Reference.utils'
import { COUNTRIES_DE } from 'src/service/view-model/base/country/CountriesDe'
import { COUNTRIES_FR } from 'src/service/view-model/base/country/CountriesFr'
import { COUNTRIES_IT } from 'src/service/view-model/base/country/CountriesIt'

export interface CountryObject extends IdAndName {
  group: string
}

const group1 = ''
const group2 = 'countryAutocompleteOther'

export const COUNTRIES: CountryObject[] = [
  { name: 'Switzerland', id: 'CH', group: group1 },
  { name: 'Germany', id: 'DE', group: group1 },
  { name: 'Austria', id: 'AT', group: group1 },
  { name: 'United Kingdom', id: 'GB', group: group1 },
  { name: 'Albania', id: 'AL', group: group2 },
  { name: 'American Samoa', id: 'AS', group: group2 },
  { name: 'Armenia', id: 'AM', group: group2 },
  { name: 'Australia', id: 'AU', group: group2 },
  { name: 'Azerbaijan', id: 'AZ', group: group2 },
  { name: 'Belarus', id: 'BY', group: group2 },
  { name: 'Belgium', id: 'BE', group: group2 },
  { name: 'Bosnia and Herzegovina', id: 'BA', group: group2 },
  { name: 'British Indian Ocean Territory', id: 'IO', group: group2 },
  { name: 'Bulgaria', id: 'BG', group: group2 },
  { name: 'Canada', id: 'CA', group: group2 },
  { name: 'China', id: 'CN', group: group2 },
  { name: 'Christmas Island', id: 'CX', group: group2 },
  { name: 'Cocos (Keeling) Islands', id: 'CC', group: group2 },
  { name: 'Croatia', id: 'HR', group: group2 },
  { name: 'Cyprus', id: 'CY', group: group2 },
  { name: 'Czech Republic', id: 'CZ', group: group2 },
  { name: 'Denmark', id: 'DK', group: group2 },
  { name: 'Ecuador', id: 'EC', group: group2 },
  { name: 'El Salvador', id: 'SV', group: group2 },
  { name: 'Estonia', id: 'EE', group: group2 },
  { name: 'Finland', id: 'FI', group: group2 },
  { name: 'France', id: 'FR', group: group2 },
  { name: 'French Guiana', id: 'GF', group: group2 },
  { name: 'Georgia', id: 'GE', group: group2 },
  { name: 'Gibraltar', id: 'GI', group: group2 },
  { name: 'Greece', id: 'GR', group: group2 },
  { name: 'Guadeloupe', id: 'GP', group: group2 },
  { name: 'Guam', id: 'GU', group: group2 },
  { name: 'Guernsey', id: 'GG', group: group2 },
  { name: 'Heard Island and Mcdonald Islands', id: 'HM', group: group2 },
  { name: 'Hong Kong', id: 'HK', group: group2 },
  { name: 'Hungary', id: 'HU', group: group2 },
  { name: 'Iceland', id: 'IS', group: group2 },
  { name: 'India', id: 'IN', group: group2 },
  { name: 'Ireland', id: 'IE', group: group2 },
  { name: 'Isle of Man', id: 'IM', group: group2 },
  { name: 'Italy', id: 'IT', group: group2 },
  { name: 'Japan', id: 'JP', group: group2 },
  { name: 'Jersey', id: 'JE', group: group2 },
  { name: 'Kazakhstan', id: 'KZ', group: group2 },
  { name: 'Latvia', id: 'LV', group: group2 },
  { name: 'Liechtenstein', id: 'LI', group: group2 },
  { name: 'Lithuania', id: 'LT', group: group2 },
  { name: 'Luxembourg', id: 'LU', group: group2 },
  { name: 'North Macedonia', id: 'MK', group: group2 },
  { name: 'Malta', id: 'MT', group: group2 },
  { name: 'Marshall Islands', id: 'MH', group: group2 },
  { name: 'Martinique', id: 'MQ', group: group2 },
  { name: 'Mayotte', id: 'YT', group: group2 },
  { name: 'Micronesia, Federated States of', id: 'FM', group: group2 },
  { name: 'Moldova, Republic of', id: 'MD', group: group2 },
  { name: 'Monaco', id: 'MC', group: group2 },
  { name: 'Nauru', id: 'NR', group: group2 },
  { name: 'Netherlands', id: 'NL', group: group2 },
  { name: 'New Zealand', id: 'NZ', group: group2 },
  { name: 'Niue', id: 'NU', group: group2 },
  { name: 'Norfolk Island', id: 'NF', group: group2 },
  { name: 'Northern Mariana Islands', id: 'MP', group: group2 },
  { name: 'Norway', id: 'NO', group: group2 },
  { name: 'Palau', id: 'PW', group: group2 },
  { name: 'Pitcairn', id: 'PN', group: group2 },
  { name: 'Poland', id: 'PL', group: group2 },
  { name: 'Portugal', id: 'PT', group: group2 },
  { name: 'Puerto Rico', id: 'PR', group: group2 },
  { name: 'Reunion', id: 'RE', group: group2 },
  { name: 'Romania', id: 'RO', group: group2 },
  { name: 'Russian Federation', id: 'RU', group: group2 },
  { name: 'Saint Pierre and Miquelon', id: 'PM', group: group2 },
  { name: 'San Marino', id: 'SM', group: group2 },
  { name: 'Slovakia', id: 'SK', group: group2 },
  { name: 'Slovenia', id: 'SI', group: group2 },
  { name: 'Spain', id: 'ES', group: group2 },
  { name: 'Sweden', id: 'SE', group: group2 },
  { name: 'Timor-Leste', id: 'TL', group: group2 },
  { name: 'Tokelau', id: 'TK', group: group2 },
  { name: 'Turkey', id: 'TR', group: group2 },
  { name: 'Turks and Caicos Islands', id: 'TC', group: group2 },
  { name: 'Ukraine', id: 'UA', group: group2 },
  { name: 'United States', id: 'US', group: group2 },
  { name: 'Virgin Islands, U.S.', id: 'VI', group: group2 },
]

export const getCountryObjectForCode = (countryCode: string | undefined): CountryObject | undefined => {
  const countryObject = findReferenceObject(COUNTRIES, countryCode, 'id')
  return countryObject
}

export const getCountryNameForLocale = (countryCode: string | undefined, userLocale: string): string => {
  let name: string | undefined

  // check for user locale specific country names
  if (countryCode) {
    const userLocaleUppercase = userLocale ? userLocale.toLocaleUpperCase() : null
    if (userLocaleUppercase) {
      let localCountryNames: Record<string, string> | null = null

      if (userLocaleUppercase === 'DE') {
        localCountryNames = COUNTRIES_DE
      } else if (userLocaleUppercase === 'FR') {
        localCountryNames = COUNTRIES_FR
      } else if (userLocaleUppercase === 'IT') {
        localCountryNames = COUNTRIES_IT
      }

      if (localCountryNames) {
        name = localCountryNames[countryCode]
      }
    }
  }

  // use english names as fallback
  if (!name) {
    const countryObject = countryCode ? getCountryObjectForCode(countryCode) : undefined

    name = countryObject ? countryObject.name : undefined
  }

  return name ?? ''
}
